import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";

import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import style from "../../assets/jss/disal-main/components/Modal";

const useStyles = makeStyles(style);

const ModalPassword = ({ open, handleClose, handleUpdatePass }) => {
  const classes = useStyles();
  const [password, setPassword] = useState("");
  const [resetPassword, setResetPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState({ password: "", resetPassword: "" });

  const handleChangePassword = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    if (name === "password") {
      setPassword(value);
    }
  };

  const handleChangeReset = (e) => {
    const value = e.target.value;
    if (password === value) {
      setResetPassword(value);
      setError({ password: "", resetPassword: "" });
    } else {
      setError({ ...error, resetPassword: "* Las contraseñas no coinciden" });
      setResetPassword(value);
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleConfirm = () => {
    let newError = { password: "", resetPassword: "" };

    if (password === "" || resetPassword === "") {
      newError.resetPassword = "*Completar los campos";
    }

    if (password !== resetPassword) {
      newError.resetPassword = "*Contraseñas no coinciden";
    }

    setError(newError);
    if (
      password !== "" &&
      resetPassword !== "" &&
      password === resetPassword
    ) {
      handleUpdatePass(resetPassword);
      handleCancel();
    }
  };

  const handleCancel = () => {
    setPassword("");
    setResetPassword("");
    setShowPassword(false);
    setError({ password: "", resetPassword: "" });
    handleClose();
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500
      }}
    >
      <Fade in={open}>
        <div className={classes.paper} style={{ width: "500px" }}>
          <div className="modal-confirm">
            <h3>Resetear Contraseña</h3>
          </div>
          <div>
            <Grid container>
              <Grid item xs={12}>
                <div className="inputs-form">
                  <Grid container>
                    <Grid item xs={4}>
                      <label>Contraseña Nueva</label>
                    </Grid>
                    <Grid item xs={8}>
                      <FormControl
                        className={classes.formControl}
                        variant="outlined"
                      >
                        <OutlinedInput
                          name="password"
                          id="outlined-adornment-password"
                          type={showPassword ? "text" : "password"}
                          value={password}
                          onChange={handleChangePassword}
                          inputProps={{
                            maxLength: 50
                          }}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                              >
                                {showPassword ? (
                                  <Visibility />
                                ) : (
                                  <VisibilityOff />
                                )}
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </div>
              </Grid>
              <Grid item xs={12}>
                <div className="inputs-form">
                  <Grid container>
                    <Grid item xs={4}>
                      <label>Repita Contraseña</label>
                    </Grid>
                    <Grid item xs={8}>
                      <FormControl
                        className={classes.formControl}
                        variant="outlined"
                      >
                        <OutlinedInput
                          name="resetPassword"
                          id="outlined-adornment-password"
                          type={showPassword ? "text" : "password"}
                          value={resetPassword}
                          onChange={handleChangeReset}
                          inputProps={{
                            maxLength: 50
                          }}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                              >
                                {showPassword ? (
                                  <Visibility />
                                ) : (
                                  <VisibilityOff />
                                )}
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                      </FormControl>
                      <p>
                        {error.resetPassword === ""
                          ? ""
                          : error.resetPassword}
                      </p>
                    </Grid>
                  </Grid>
                </div>
              </Grid>
            </Grid>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn-modal-salida"
              style={{ textDecoration: "underline", marginRight: "10px" }}
              onClick={handleCancel}
            >
              Cancelar
            </button>
            <button
              type="button"
              className="btn-modal-salida"
              style={{ textDecoration: "underline", marginRight: "10px" }}
              onClick={handleConfirm}
            >
              Confirmar
            </button>
          </div>
        </div>
      </Fade>
    </Modal>
  );
};
export default ModalPassword;
